import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { StepOneProps, commonStyles } from './types';

export const BasicInfoSection: React.FC<StepOneProps> = ({ values, onChange, errors, touched }) => {
  const { inputClassName, labelClassName, errorClassName } = commonStyles;

  const categories = [
    { label: 'Sécurité', value: 'security' },
    { label: 'Réglementation', value: 'regulation' },
    { label: 'Conduite', value: 'driving' },
    { label: 'Maintenance', value: 'maintenance' }
  ];

  return (
    <div className="space-y-6">
      <div>
        <label htmlFor="title" className={labelClassName}>
          Titre du chapitre
        </label>
        <InputText
          id="title"
          name="title"
          value={values.title}
          onChange={onChange}
          className={inputClassName}
        />
        {errors?.title && touched?.title && (
          <div className={errorClassName}>{errors.title}</div>
        )}
      </div>

      <div>
        <label htmlFor="category" className={labelClassName}>
          Catégorie
        </label>
        <Dropdown
          id="category"
          name="category"
          value={values.category}
          options={categories}
          onChange={onChange}
          className={inputClassName}
          placeholder="Sélectionnez une catégorie"
        />
        {errors?.category && touched?.category && (
          <div className={errorClassName}>{errors.category}</div>
        )}
      </div>

      <div>
        <label htmlFor="description" className={labelClassName}>
          Description
        </label>
        <InputTextarea
          id="description"
          name="description"
          value={values.description}
          onChange={onChange}
          rows={4}
          className={inputClassName}
          autoResize
        />
        {errors?.description && touched?.description && (
          <div className={errorClassName}>{errors.description}</div>
        )}
      </div>
    </div>
  );
};
